// src/modules/requerimiento/views/index.js
import AdicionProgramacion from "./adicion/Programacion";
import AdicionTrabajoCampo from "./adicion/TrabajoCampo";
import AdicionRevisionSistemas from "./adicion/RevisionSistemas";
import AdicionCampo from "./adicion/AdicionCampo";
import { normTipoAdicion } from "../utils/payload";

import DevolucionProgramacion from "./devolucion/Programacion";
import DevolucionTrabajoCampo from "./devolucion/TrabajoCampo";
import DevolucionRevisionSistemas from "./devolucion/RevisionSistemas";

import MantenimientoProgramacion from "./mantenimiento/Programacion";
import MantenimientoTrabajoCampo from "./mantenimiento/TrabajoCampo";
import MantenimientoRevisionSistemas from "./mantenimiento/RevisionSistemas";

// Normaliza el tipo (por si llega "Adición", "adicion", etc.)
const norm = (s = "") =>
  s.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toUpperCase();

export const getViewFor = (tipo, estado, tipoAdicion = "", esTransferenciaCliente = false) => {
  const T = norm(tipo);
  const E = Number(estado);

  // Adición de equipo nuevo: sin Programación. Desde que se emite (o desde 1/2 si es anterior al
  // cambio) los equipos se asignan e instalan en la misma vista de Trabajo de campo.
  // La vinculación adicional sigue con su Programación.
  if (T === "ADICION" && normTipoAdicion(tipoAdicion) !== "VINCULACION_ADICIONAL" && [1, 2, 3, 4].includes(E)) {
    return AdicionCampo;
  }

  // Devolución: sin Programación. El formulario de devolver equipos (el que era la Programación)
  // es el Trabajo de campo, desde la emisión (o desde 1/2 si es anterior al cambio). La devolución
  // con transferencia de cliente sigue con su confirmación en Programación.
  if (T === "DEVOLUCION" && !esTransferenciaCliente && [1, 2, 3, 4].includes(E)) {
    return DevolucionProgramacion;
  }

  // Mantenimiento: sin Programación. Los equipos de las placas se agregan desde el Trabajo de campo
  // ("Agregar equipos"), desde la emisión o desde 1/2 si es anterior al cambio.
  if (T === "MANTENIMIENTO" && [1, 2, 3, 4].includes(E)) {
    return MantenimientoTrabajoCampo;
  }

  const registry = {
    ADICION: {
      0: AdicionRevisionSistemas,
      2: AdicionProgramacion,
      3: AdicionTrabajoCampo,
      4: AdicionTrabajoCampo,
      5: AdicionRevisionSistemas,
      7: AdicionRevisionSistemas,
      8: AdicionRevisionSistemas,
    },
    DEVOLUCION: {
      0: DevolucionRevisionSistemas,
      2: DevolucionProgramacion,
      3: DevolucionTrabajoCampo,
      4: DevolucionTrabajoCampo,
      5: DevolucionRevisionSistemas,
      7: DevolucionRevisionSistemas,
      8: DevolucionRevisionSistemas,
    },
    MANTENIMIENTO: {
      0: MantenimientoRevisionSistemas,
      2: MantenimientoProgramacion,
      3: MantenimientoTrabajoCampo,
      5: MantenimientoRevisionSistemas,
      7: MantenimientoRevisionSistemas,
      8: MantenimientoRevisionSistemas,
    },
  };

  // Si no hay match, intenta “Programación (2)” y finalmente null
  return registry[T]?.[E] || registry[T]?.[2] || null;
};
